<div class="event-types-container">
  <div class="row justify-content-between">
    <div class="col-4">
      <div class="md-form w-100 mr-2 experienceAttribute-search">
        <input
          class="form-control"
          id="search"
          type="search"
          mdbInput
          [(ngModel)]="experienceAttributesSearchText"
        />
        <label for="search">Search Experience Attributes</label>
      </div>
    </div>
    <div class="col-3">
      <div class="btn-spacing text-right">
        <button
          class="theme-modal-button btn"
          type="button"
          mdbBtnp
          mdbWavesEffect
          (click)="manageExperienceAttribute('add')"
        >
          <mdb-icon far icon="plus-square" class="pr-1"></mdb-icon>
          Add Experience Attribute
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" *ngIf="!experienceAttributesLoading">
      <div class="card-group">
        <div
          *ngFor="
            let experienceAttribute of experienceAttributes | filter : experienceAttributesSearchText;
            let i = index
          "
        >
          <mdb-card>
            <mdb-card-body>
              <mdb-card-title>
                <h5 class="mb-3">{{ experienceAttribute.label }}</h5>
              </mdb-card-title>
              <mdb-card-text class="mb-0">
                <ul class="list-unstyled">
                  <li>
                    {{ experienceAttribute.description }}
                  </li>
                </ul>
              </mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer class="modal-footer">
              <a
                (click)="manageExperienceAttribute('edit', i, experienceAttribute)"
                mdbTooltip="Edit"
                placement="top"
              >
                <mdb-icon far icon="edit"></mdb-icon>
              </a>
              <a
                (click)="archiveExperienceAttribute(experienceAttribute)"
                mdbTooltip="Archive"
                placement="top"
              >
                <mdb-icon fas icon="archive"></mdb-icon>
              </a>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </div>
    </div>
  </div>
</div>
